import { gql } from 'apollo-angular'

import {
  ARTICLE_REFERENCE_FIELDS,
  ARTICLE_WITH_AUTHORS_FIELDS,
} from '../../fragments/article-fragments'

export const GET_ARTICLES_FOR_MULTIPLE_EDITIONS = gql`
  ${ARTICLE_WITH_AUTHORS_FIELDS}
  ${ARTICLE_REFERENCE_FIELDS}
  query getArticlesForMultipleEditions($editionIds: [JSON!]!) {
    Articles(
      where: {
        AND: [
          { edition: { in: $editionIds } }
          { published_at: { not_equals: null } }
        ]
      }
      sort: "edition_order"
    ) {
      docs {
        ...ArticleWithAuthorsFields
        ...ArticleReferenceFields
        sub_articles {
          ...ArticleWithAuthorsFields
        }
      }
    }
  }
`
